import { createSlice } from "@reduxjs/toolkit";

const MEMBER_PROFILE_STATE = {
  profile: null,
  profileLoading: false,
  profileError: null,
};

const memberProfileSlice = createSlice({
  name: "MEMBER_PROFILE_SLICE",
  initialState: MEMBER_PROFILE_STATE,
  reducers: {
    startGetProfile: (state) => {
      state.profileLoading = true;
      state.profileError = null;
    },
    successGetProfile: (state, action) => {
      state.profileLoading = false;
      state.profile = action.payload;
    },
    errorGetProfile: (state, action) => {
      state.profileLoading = false;
      state.profileError = action.payload;
    },
    updateProfile: (state, action) => {
      state.profile = { ...state.profile, ...action.payload };
    },
    clearProfile: (state) => {
      state.profile = null;
      state.profileError = null;
    },
  },
});

export const {
  startGetProfile,
  successGetProfile,
  errorGetProfile,
  updateProfile,
  clearProfile,
} = memberProfileSlice.actions;

export const memberProfileReducer = memberProfileSlice.reducer;
